import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LogIn, X } from 'lucide-react';

export default function LoginPromptModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();

  if (!isOpen) return null;

  const handleLogin = () => {
    onClose();
    navigate('/login', { state: { from: location } });
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4 backdrop-blur-sm animate-in fade-in duration-200">
      <div 
        className="bg-white rounded-3xl w-full max-w-sm overflow-hidden shadow-2xl animate-in zoom-in-95 duration-200 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-full hover:bg-gray-100 z-10"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="p-8 pb-6 flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-6 shadow-sm border border-blue-100">
            <LogIn className="w-8 h-8 text-blue-500" />
          </div>
          
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            需要登入才能繼續
          </h3>
          <p className="text-gray-500 text-sm mb-8 leading-relaxed px-4">
            加入 JoGather 即可報名活動、留言互動，與大家一起同樂！
          </p>

          <div className="w-full space-y-3">
            <button
              onClick={handleLogin}
              className="w-full bg-[#4e8bca] hover:bg-[#3d70a5] text-white font-semibold py-3.5 px-4 rounded-xl transition-all shadow-md hover:shadow-lg active:scale-[0.98]"
            >
              前往登入 / 註冊
            </button>
            <button
              onClick={onClose}
              className="w-full bg-gray-50 hover:bg-gray-100 text-gray-600 font-medium py-3.5 px-4 rounded-xl transition-colors active:scale-[0.98]"
            >
              先逛逛
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
